import { useMemo } from 'react'

import { BREAKPOINTS } from '../constants'
import { useWindowSize } from './use-window-size'

/**
 * HINT: Артёмка, используй этот хук вместо useDeviceDetection из web-ui
 * Этот хук учитывает планшеты и большие десктопы
 */
export const useDeviceDetect = () => {
    const { width } = useWindowSize()

    const breakpoint = useMemo(() => {
        if (width <= BREAKPOINTS.MOBILE) {
            return 0
        }

        if (width <= BREAKPOINTS.TABLET && width > BREAKPOINTS.MOBILE) {
            return BREAKPOINTS.MOBILE
        }

        if (width <= BREAKPOINTS.DESKTOP && width > BREAKPOINTS.TABLET) {
            return BREAKPOINTS.TABLET
        }

        if (width <= BREAKPOINTS.DESKTOP_XL && width > BREAKPOINTS.DESKTOP) {
            return BREAKPOINTS.DESKTOP
        }

        return BREAKPOINTS.DESKTOP_XL
    }, [width])

    return {
        breakpoint,
        isMobile: width <= BREAKPOINTS.MOBILE,
        isTablet: width > BREAKPOINTS.MOBILE && width <= BREAKPOINTS.TABLET,
        isDesktop: width > BREAKPOINTS.TABLET && width <= BREAKPOINTS.DESKTOP,
        isDesktopXL: width > BREAKPOINTS.DESKTOP,
    }
}
